import type { BatchJobSummary } from '@/hooks/useWorkflowBatchJobs';

export type BatchJobDayGroup = {
  key: string;
  label: string;
  jobs: BatchJobSummary[];
};

const dayKey = (d: Date): string =>
  `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;

const absoluteLabel = (d: Date): string =>
  d.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

function labelFor(date: Date, now: Date): string {
  if (dayKey(date) === dayKey(now)) {
    return 'Today';
  }
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (dayKey(date) === dayKey(yesterday)) {
    return 'Yesterday';
  }
  return absoluteLabel(date);
}

export function groupJobsByDay(
  jobs: readonly BatchJobSummary[],
  now: Date
): BatchJobDayGroup[] {
  const groups: BatchJobDayGroup[] = [];
  const byKey = new Map<string, BatchJobDayGroup>();

  for (const job of jobs) {
    const date = new Date(job.createdAt);
    const key = dayKey(date);
    const existing = byKey.get(key);
    if (existing) {
      existing.jobs.push(job);
      continue;
    }
    const group = { key, label: labelFor(date, now), jobs: [job] };
    byKey.set(key, group);
    groups.push(group);
  }

  return groups;
}
